import type { ApiAxis, ApiSku } from "@/lib/api";
import { isInquiryOnly, optionDisabled, type Selection } from "@/lib/cms-variants";
import { RadioCard, RadioGroup } from "@/components/ui/radio-group";

/** Tile buttons for a text axis such as size — the control the CMS calls "select". */
export function SizePicker({
  axis,
  skus,
  selection,
  onChange,
  labelledBy,
}: {
  axis: ApiAxis;
  skus: ApiSku[];
  selection: Selection;
  onChange: (valueId: string) => void;
  labelledBy: string;
}) {
  const values = axis.optionType.values.filter((v) => axis.valueIds.includes(v.id));
  return (
    <RadioGroup
      value={selection[axis.optionTypeId] ?? ""}
      onValueChange={onChange}
      aria-labelledby={labelledBy}
      className="grid grid-cols-2 gap-2 sm:grid-cols-3"
    >
      {values.map((v) => {
        const disabled = optionDisabled(skus, selection, axis.optionTypeId, v.id, [axis]);
        const inquiry = isInquiryOnly([axis], axis.optionTypeId, v.id);
        return (
          <RadioCard key={v.id} value={v.id} disabled={disabled} className="justify-center text-center">
            <span className="flex flex-col items-center gap-0.5">
              <span className="font-medium">{v.label}</span>
              {/* Not "Habis": there is nothing to run out of. It is made to order. */}
              {inquiry ? (
                <span className="text-xs text-brand">Konsultasi</span>
              ) : (
                disabled && <span className="text-xs text-ink/50">Habis</span>
              )}
            </span>
          </RadioCard>
        );
      })}
    </RadioGroup>
  );
}
